"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const Cell2Widget_1 = tslib_1.__importDefault(require("../model/Cell2Widget"));
const HeaderCell2Widget_1 = tslib_1.__importDefault(require("../model/HeaderCell2Widget"));
const FooterCell2Widget_1 = tslib_1.__importDefault(require("../model/FooterCell2Widget"));
class RenderingContext {
    constructor() {
        this.cell2WidgetList = [];
        this.headerCell2WidgetList = [];
        this.footerCell2WidgetList = [];
        this.htmlOutput = "";
        this.columnDataDisplayType = [];
    }
    text(text) {
        this.htmlOutput += (0, fmko_ts_common_1.htmlEncode)(text);
    }
    html(html) {
        this.htmlOutput += html;
    }
    resetHTML() {
        this.htmlOutput = "";
    }
    toString() {
        return this.htmlOutput;
    }
    getCell2Widget() {
        return this.cell2WidgetList;
    }
    setWidget(widget) {
        this.cell2WidgetList.push(new Cell2Widget_1.default(this.row, this.column, widget));
    }
    getHeaderWidget() {
        return this.headerCell2WidgetList;
    }
    setHeaderWidget(widget) {
        this.headerCell2WidgetList.push(new HeaderCell2Widget_1.default(this.column, widget));
    }
    getFooterWidget() {
        return this.footerCell2WidgetList;
    }
    setFooterWidget(widget, rowNumber, column) {
        this.footerCell2WidgetList.push(new FooterCell2Widget_1.default(rowNumber, column, widget));
    }
    getColumnDataDisplayTypes() {
        return this.columnDataDisplayType || [];
    }
    getColumnDataDisplayType(columnIndex) {
        return this.columnDataDisplayType[columnIndex];
    }
    setColumnDataDisplayType(type) {
        this.columnDataDisplayType[this.column] = type;
    }
}
exports.default = RenderingContext;
//# sourceMappingURL=RenderingContext.js.map